import {
  Backdrop,
  CircularProgress,
  Container,
  Grid,
  Stack,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { MgpButton, MgpDD } from "../components/global";
import { ENV } from "../helpers";
import { useEncounter, useMaster } from "../hooks";
import { useEffect, useRef, useState } from "react";
import { StorageHelper } from "../helpers";
import { MgpDatePickerOther } from "../components/global/MgpDatePickerOther";

export const DashboardFilter = ({
  setMainPageloading,
  closed = () => { },
  handleChange: applyFilters = () => { },
  isAnalytics,
  viewType,
  self,
  initialValues: savedValues,
}) => {
  const { hospitals, countries } = useMaster();
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const validationSchema = yup.object().shape({});
  const user = JSON.parse(StorageHelper.get("user"));
  const assigned_hospitals = JSON.parse(
    StorageHelper.get("assigned_hospitals")
  );
  var filterHospitals = hospitals.filter((x) =>
    assigned_hospitals?.includes(x.value)
  );
  const { useGetVisitType } = useEncounter({patientId:1});
  const emptyValues = {
    country_id: "",
    hospital_id: "",
    hospital_ids: [],
    visit_type: [],
    from: "",
    to: "",
  };
  const initialValues = { ...emptyValues, ...savedValues };
  const [GetVisitType, { data, loading }] = useGetVisitType;
  const formikRef = useRef();
  const isItkanUser = parseInt(user?.role_id) === parseInt(ENV.itkan_role_id);
  const baseHospitalOptions =
    assigned_hospitals?.length > 0 ? filterHospitals : hospitals;

  const normalizeDashboardFilters = (values) => {
    const filters = { ...values };

    if (isItkanUser) {
      const countryId = Number(filters.country_id);
      if (filters.country_id && Number.isFinite(countryId)) {
        filters.country_id = countryId;
      } else {
        delete filters.country_id;
      }

      const hospitalIds = (Array.isArray(filters.hospital_ids)
        ? filters.hospital_ids
        : filters.hospital_ids
          ? [filters.hospital_ids]
          : []
      )
        .map(Number)
        .filter(Number.isFinite);

      delete filters.hospital_id;

      if (hospitalIds.length) {
        filters.hospital_ids = hospitalIds;
      } else {
        delete filters.hospital_ids;
      }
    } else {
      delete filters.country_id;
      delete filters.hospital_ids;
      if (!filters.hospital_id) {
        delete filters.hospital_id;
      }
    }

    if (!filters.visit_type?.length) {
      delete filters.visit_type;
    }
    if (!filters.from) {
      delete filters.from;
    }
    if (!filters.to) {
      delete filters.to;
    }

    return filters;
  };

  const getHospitalOptions = (countryId) => {
    if (!isItkanUser || !countryId) {
      return baseHospitalOptions;
    }

    return baseHospitalOptions.filter(
      (hospital) => String(hospital.country_id) === String(countryId)
    );
  };

  const renderCountryFilter = ({
    values,
    setFieldValue,
    handleBlur,
    touched,
    errors,
  }) => {
    if (!isItkanUser) return null;

    return (
      <Grid item md={6}>
        <MgpDD
          label="Country"
          variant="outlined"
          size="small"
          name="country_id"
          fullWidth
          value={values.country_id}
          options={countries}
          onChange={(e) => {
            const nextCountryId = e.target.value;
            setFieldValue("country_id", nextCountryId);
            setFieldValue("hospital_id", "");
            setFieldValue("hospital_ids", []);
          }}
          onBlur={handleBlur}
          error={Boolean(touched.country_id && errors.country_id)}
          helperText={touched.country_id && errors.country_id}
        />
      </Grid>
    );
  };

  const renderHospitalFilter = ({
    values,
    setFieldValue,
    handleBlur,
    touched,
    errors,
  }) => {
    const hospitalFieldName = isItkanUser ? "hospital_ids" : "hospital_id";
    const hospitalOptions = getHospitalOptions(values.country_id);

    return (
      <Grid item md={6}>
        <MgpDD
          label="Hospital"
          variant="outlined"
          size="small"
          name={hospitalFieldName}
          multiselect={isItkanUser}
          fullWidth
          value={values[hospitalFieldName]}
          options={hospitalOptions}
          onChange={(e) => {
            setFieldValue(hospitalFieldName, e.target.value);
          }}
          onBlur={handleBlur}
          error={Boolean(
            touched[hospitalFieldName] && errors[hospitalFieldName]
          )}
          helperText={touched[hospitalFieldName] && errors[hospitalFieldName]}
        />
      </Grid>
    );
  };

  const previousSelf = useRef(self);
  useEffect(() => {
    GetVisitType({
      fetchPolicy: "cache-and-network",
      variables:{self: self === "1" ? true : false},
    })
    if (previousSelf.current !== self) {
      previousSelf.current = self;
      formikRef.current?.resetForm({ values: emptyValues });
    }
  }, [self])
  return (
    <>
      <Container fluid>
        <Formik
          initialValues={initialValues}
          innerRef={formikRef}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            // setMainPageloading(true);
            // setLoadingSubmit(true);
            applyFilters(normalizeDashboardFilters(values), viewType, values);
          }}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            resetForm,
            touched,
            errors,
            values,
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                {(user?.role_id == ENV.itkan_role_id ||
                  user?.role_id == ENV.quality_user_role_id) &&
                  (viewType === "graph" || viewType === "table") && (
                    <>
                      {renderCountryFilter({
                        values,
                        setFieldValue,
                        handleBlur,
                        touched,
                        errors,
                      })}
                      {renderHospitalFilter({
                        values,
                        setFieldValue,
                        handleBlur,
                        touched,
                        errors,
                      })}
                      {isAnalytics ? (
                        <Grid item md={6}>
                          <MgpDD
                            label="Visit Type"
                            variant="outlined"
                            size="small"
                            name="visit_type"
                            multiselect={true}
                            fullWidth
                            value={values.visit_type}
                            options={data?.GetVisitType}
                            onChange={(e) => {
                              setFieldValue("visit_type", e.target.value);
                            }}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.visit_type && errors.visit_type
                            )}
                            helperText={touched.visit_type && errors.visit_type}
                          />
                        </Grid>
                      ) : (
                        // Spacer only when Hospital alone occupies the first row
                        // (quality users). ITKAN already fills the row with Country + Hospital.
                        !isItkanUser && <Grid item md={6}></Grid>
                      )}
                    </>
                  )}

                {(user?.role_id == ENV.itkan_role_id ||
                  user?.role_id == ENV.quality_user_role_id) &&
                  isAnalytics && (
                    <>
                      {renderCountryFilter({
                        values,
                        setFieldValue,
                        handleBlur,
                        touched,
                        errors,
                      })}
                      {renderHospitalFilter({
                        values,
                        setFieldValue,
                        handleBlur,
                        touched,
                        errors,
                      })}
                      {parseInt(user?.role_id) !== parseInt(ENV.itkan_role_id) &&
                        <Grid item md={6}></Grid>}
                    </>
                  )}

                {(user?.role_id == ENV.doctor_role_id || user?.role_id == ENV.itkan_role_id ||
                  user?.role_id == ENV.medical_lead_role_id) &&
                  isAnalytics && (
                    <>
                      <Grid item md={6}>
                        <MgpDD
                          label="Visit Type"
                          variant="outlined"
                          size="small"
                          name="visit_type"
                          multiselect={true}
                          fullWidth
                          value={values.visit_type}
                          options={data?.GetVisitType}
                          onChange={(e) => {
                            setFieldValue("visit_type", e.target.value);
                          }}
                          onBlur={handleBlur}
                          error={Boolean(
                            touched.visit_type && errors.visit_type
                          )}
                          helperText={touched.visit_type && errors.visit_type}
                        />
                      </Grid>
                      {parseInt(user?.role_id) !== parseInt(ENV.itkan_role_id) &&
                        <Grid item md={6}></Grid>
                      }
                    </>
                  )}

                <Grid item md={6}>
                  <MgpDatePickerOther
                    viewMode={false}
                    size="small"
                    fullWidth
                    onChange={setFieldValue}
                    errors={Boolean(errors?.["from"] && touched?.["from"])}
                    setFieldValue={setFieldValue}
                    touched={touched}
                    handleChange={handleChange}
                    label={"From"}
                    name={"from"}
                    values={values}
                    handleBlur={handleBlur}
                    startDate={"Form_Date"}
                    disablePast={false}
                    monthly={true}
                    disableFuture={true}
                    removetoday={true}
                    variant="outlined"
                  />
                </Grid>

                <Grid item md={6}>
                  <MgpDatePickerOther
                    viewMode={false}
                    size="small"
                    fullWidth
                    onChange={setFieldValue}
                    errors={Boolean(errors?.["to"] && touched?.["to"])}
                    setFieldValue={setFieldValue}
                    touched={touched}
                    handleChange={handleChange}
                    label={"To"}
                    name={"to"}
                    values={values}
                    handleBlur={handleBlur}
                    startDate={"To_Date"}
                    disablePast={false}
                    monthly={true}
                    disableFuture={true}
                    removetoday={true}
                    variant="outlined"
                  />
                </Grid>

                <Grid item md={12}>
                  <Stack
                    spacing={2}
                    justifyContent={"flex-end"}
                    direction={"row"}
                  >
                    <MgpButton
                      type="button"
                      onClick={() => {
                        resetForm({ values: emptyValues });
                        applyFilters(
                          normalizeDashboardFilters(emptyValues),
                          viewType,
                          emptyValues
                        );
                      }}
                      variant="contained"
                    >
                      Clear
                    </MgpButton>
                    <MgpButton type="submit" variant="contained">
                      Apply
                    </MgpButton>
                  </Stack>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Container>
      {loadingSubmit && (
        <Backdrop open={loadingSubmit} style={{ zIndex: 1 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </>
  );
};
